import { Box } from "@mui/material";

type Props = {
  width?: number;
  height?: number;
  handleClick?: () => void;
};

const VaultIcon = ({ width, height, handleClick }: Props) => {
  return (
    <Box
      data-testid="vault-icon"
      onClick={handleClick}
      sx={{ cursor: handleClick ? "pointer" : "default" }}
    >
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        width={width || 730}
        height={height || 730}
        viewBox="0, 0, 730, 730"
      >
        <g id="Layer_1">
          <path
            d="M664.44,95.71 C663.67,95.7 586.36,93.9 507.92,66.27 C425.01,37.07 372.2,4.88 371.69,4.56 L365.01,0.45 L358.33,4.55 C357.81,4.87 305,37.06 222.08,66.26 C143.83,93.82 66.33,95.68 65.56,95.7 L53.05,95.94 L53.05,421.14 C53.05,422.67 53.23,459.22 68.97,506.66 C83.52,550.5 114.72,612.33 180.75,657.92 C262.82,714.59 359.16,728.71 363.22,729.28 L365,729.53 L366.78,729.28 C370.84,728.71 467.18,714.59 549.25,657.92 C615.27,612.33 646.48,550.5 661.03,506.66 C676.77,459.23 676.95,422.68 676.95,421.14 L676.95,95.95 L664.44,95.71 z M224.37,546.61 C204.06,546.61 187.59,530.14 187.59,509.83 C187.59,489.52 204.06,473.05 224.37,473.05 C244.68,473.05 261.15,489.52 261.15,509.83 C261.15,530.14 244.68,546.61 224.37,546.61 z M224.37,409.72 C204.06,409.72 187.59,393.25 187.59,372.94 C187.59,352.63 204.06,336.16 224.37,336.16 C244.68,336.16 261.15,352.63 261.15,372.94 C261.15,393.25 244.68,409.72 224.37,409.72 z M224.37,272.83 C204.06,272.83 187.59,256.36 187.59,236.05 C187.59,215.74 204.06,199.27 224.37,199.27 C244.68,199.27 261.15,215.74 261.15,236.05 C261.15,256.36 244.68,272.83 224.37,272.83 z M361.01,546.61 C340.7,546.61 324.23,530.14 324.23,509.83 C324.23,489.52 340.7,473.05 361.01,473.05 C381.32,473.05 397.79,489.52 397.79,509.83 C397.79,530.14 381.32,546.61 361.01,546.61 z M361.01,409.72 C340.7,409.72 324.23,393.25 324.23,372.94 C324.23,352.63 340.7,336.16 361.01,336.16 C381.32,336.16 397.79,352.63 397.79,372.94 C397.79,393.25 381.32,409.72 361.01,409.72 z M361.01,272.83 C340.7,272.83 324.23,256.36 324.23,236.05 C324.23,215.74 340.7,199.27 361.01,199.27 C381.32,199.27 397.79,215.74 397.79,236.05 C397.79,256.36 381.32,272.83 361.01,272.83 z M497.65,409.72 C477.34,409.72 460.87,393.25 460.87,372.94 C460.87,352.63 477.34,336.16 497.65,336.16 C517.96,336.16 534.43,352.63 534.43,372.94 C534.43,393.25 517.96,409.72 497.65,409.72 z M497.65,272.83 C477.34,272.83 460.87,256.36 460.87,236.05 C460.87,215.74 477.34,199.27 497.65,199.27 C517.96,199.27 534.43,215.74 534.43,236.05 C534.43,256.36 517.96,272.83 497.65,272.83 z"
            fill="#0C053F"
          />
          <path
            d="M534.43,509.83 C534.43,530.143 517.963,546.61 497.65,546.61 C477.337,546.61 460.87,530.143 460.87,509.83 C460.87,489.517 477.337,473.05 497.65,473.05 C517.963,473.05 534.43,489.517 534.43,509.83 z"
            fill="#16DE6A"
          />
        </g>
      </svg>
    </Box>
  );
};

export default VaultIcon;
